// Predefined color schemes for reports and widgets
// Each scheme has colors for primary items, secondary items, and accent colors

export const COLOR_SCHEMES = {
  default: {
    name: 'Default',
    primary: ['#0E2E96', '#E57702','#C73039','#028C4E',  ],
    secondary: ['#6588DF', '#EE8E81', '#5ADC87', '#F7BE64'],
    accent: ['#1B43BA', '#961010', '#01644B', '#A44501'],
    background: 'rgba(252, 253, 253, 0.8)',
  },
  ocean: {
    name: 'Ocean',
    primary: ['#0077B6', '#00B4D8', '#0096C7', '#48CAE4'],
    secondary: ['#90E0EF', '#ADE8F4', '#CAF0F8', '#023E8A'],
    accent: ['#03045E', '#0077B6', '#00B4D8', '#90E0EF'],
    background: 'rgba(240, 249, 255, 0.8)',
  },
  forest: {
    name: 'Forest',
    primary: ['#1B4332', '#2D6A4F', '#40916C', '#52B788'],
    secondary: ['#74C69D', '#95D5B2', '#B7E4C7', '#D8F3DC'],
    accent: ['#081C15', '#1B4332', '#2D6A4F', '#40916C'],
    background: 'rgba(232, 246, 239, 0.8)',
  },
  sunset: {
    name: 'Sunset',
    primary: ['#F94144', '#F3722C', '#F8961E', '#F9C74F'],
    secondary: ['#90BE6D', '#43AA8B', '#577590', '#F9844A'],
    accent: ['#F94144', '#F3722C', '#F8961E', '#90BE6D'],
    background: 'rgba(255, 246, 235, 0.8)',
  },
  pastel: {
    name: 'Pastel',
    primary: ['#7F5283', '#A6D1E6', '#FEFBF6', '#F5BFDC'],
    secondary: ['#B7CADB', '#D3DEDC', '#92A9BD', '#FEFBF6'],
    accent: ['#7F5283', '#445069', '#F5BFDC', '#D3DEDC'],
    background: 'rgba(249, 247, 252, 0.8)',
  },
  monochrome: {
    name: 'Monochrome',
    primary: ['#2E3440', '#3B4252', '#434C5E', '#4C566A'],
    secondary: ['#D8DEE9', '#E5E9F0', '#ECEFF4', '#8FBCBB'],
    accent: ['#5E81AC', '#81A1C1', '#88C0D0', '#8FBCBB'],
    background: 'rgba(236, 239, 244, 0.8)',
  }
};

// Function to get colors for a specific number of items in a scheme
export const getSchemeColors = (scheme = 'default', count = 4, type = 'primary') => {
  const selectedScheme = COLOR_SCHEMES[scheme] || COLOR_SCHEMES.default;
  const colors = selectedScheme[type] || selectedScheme.primary;
  
  // If we need more colors than available, repeat the colors
  if (count <= colors.length) {
    return colors.slice(0, count);
  }
  
  const result = [];
  for (let i = 0; i < count; i += 1) {
    result.push(colors[i % colors.length]);
  }
  return result;
};

// Function to get a specific color from a scheme
export const getSchemeColor = (scheme = 'default', index = 0, type = 'primary') => {
  const selectedScheme = COLOR_SCHEMES[scheme] || COLOR_SCHEMES.default;
  const colors = selectedScheme[type] || selectedScheme.primary;
  return colors[index % colors.length];
};

// Function to get the background color for a scheme
export const getSchemeBackground = (scheme = 'default') => {
  const selectedScheme = COLOR_SCHEMES[scheme] || COLOR_SCHEMES.default;
  return selectedScheme.background;
}; 